module.exports = __webpack_public_path__ + "static/media/coxinhadefrango.7de0d992.webp";